/* eslint-disable @ok/oklint/no-hardcode-jsx */
import React from 'react';
import { calc } from '@ok/blade';
import MediaQuery from '@ok/okg/src/react/MediaQuery';
import { toLocale } from '@common/i18n';
import getCoinIconUrl from '@common/utils/CoinIcons';
import { get } from '@common/utils/dataProxy';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // import standard utc
import timezone from 'dayjs/plugin/timezone';

import './Table.less'; // import timezone

dayjs.extend(utc);
dayjs.extend(timezone);

const INDEX_PRICE_BUY_TRADING_PAIR =
  '/v2/support/home/price-index/btc_jpy/getData';

class Table extends React.Component {
  constructor() {
    super();
    this.state = {
      currencyName: 'BTC',
      tableData: [],
      createTime: null,
    };
  }

  componentDidMount() {
    this.getCurrencyData();
  }

  async getCurrencyData() {
    try {
      const res = await get(INDEX_PRICE_BUY_TRADING_PAIR, {
        pageSize: 2,
      });
      const { entries } = res;
      const tableData = entries.slice(0, 2).map((item, index) => {
        const date =
          index === 0
            ? toLocale('btc_index_crypto_currency_today')
            : toLocale('btc_index_crypto_currency_yesterday');
        return { ...item, date };
      });
      const utcTime = dayjs.utc(tableData[0].calculateTime);
      const localTime = utcTime.tz('Asia/Tokyo');

      const createTime = dayjs(localTime).format(
        `YYYY${toLocale('btc_index_year_split_symbol')}MM${toLocale(
          'btc_index_month_split_symbol'
        )}DD${toLocale('btc_index_day_split_symbol')} HH:mm`
      );
      this.setState({ tableData, createTime });
    } catch (err) {
      console.log(err);
    }
  }

  formatPrice(value) {
    return `${calc.thousandFormat(value)} ${toLocale(
      'btc_index_crypto_currency_unit'
    )} `;
  }

  render() {
    const { tableData, currencyName, createTime } = this.state;

    const TablePC = (
      <>
        <div className="btc-index-table-title">
          <div>{toLocale('btc_index_crypto_currency_name')}</div>
          <div>{toLocale('btc_index_crypto_currency_purchase')}</div>
          <div>{toLocale('btc_index_crypto_currency_sell')}</div>
          <div>{toLocale('btc_index_crypto_currency_market_price')}</div>
        </div>
        <div className="btc-index-table-body">
          <div className="btc-index-table-row">
            <div className="btc-index-table-info-box">
              <img
                src={getCoinIconUrl(currencyName, 120)}
                alt={`${currencyName} icon`}
              />
              <div className="btc-index-table-info">
                <div className="currency-symbol">BTC</div>
                <div className="currency-name">
                  {toLocale('btc_index_crypto_currency_btc')}
                </div>
              </div>
            </div>
            <div className="btc-index-table-data">
              {tableData.map((data, index) => {
                return (
                  <div className="btc-index-table-data-col" key={index}>
                    <div className="btc-index-table-date">{data.date}</div>
                    <div>{this.formatPrice(data.bidPrice)}</div>
                    <div>{this.formatPrice(data.askPrice)}</div>
                    <div>{this.formatPrice(data.avgPrice)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );

    const TableMobile = (
      <div className="btc-index-table-body-mobile">
        <div className="btc-index-table-row">
          <div className="btc-index-table-info-box">
            <img
              src={getCoinIconUrl(currencyName, 120)}
              alt={`${currencyName} icon`}
            />
            <div className="btc-index-table-info">
              <div className="currency-symbol">BTC</div>
              <div className="currency-name">ビットコイン</div>
            </div>
          </div>
          <div className="btc-index-table-data">
            {tableData.map((data, index) => {
              return (
                <div className="btc-index-table-data-col" key={index}>
                  <div className="btc-index-table-date">{data.date}</div>
                  <div className="btc-index-table-list">
                    <div className="list-item">
                      <div>
                        {toLocale('btc_index_crypto_currency_purchase')}
                      </div>
                      <div>{this.formatPrice(data.bidPrice)}</div>
                    </div>
                    <div className="list-item">
                      <div>{toLocale('btc_index_crypto_currency_sell')}</div>
                      <div>{this.formatPrice(data.askPrice)}</div>
                    </div>
                    <div className="list-item">
                      <div>
                        {toLocale('btc_index_crypto_currency_market_price')}
                      </div>
                      <div>{this.formatPrice(data.avgPrice)}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
    return (
      <div className="btc-index-table-box">
        {createTime && (
          <div className="time-tips-box">
            {toLocale('btc_index_crypto_currency_date')}: {createTime} JST
          </div>
        )}
        {tableData.length > 0 && (
          <div className="btc-index-table">
            <MediaQuery
              sm={TableMobile}
              md={TableMobile}
              lg={TablePC}
              xl={TablePC}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Table;
